// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"fe9c2e44","480":"676699e0","647":"eb0516e6","972":"013c7e2f"}[chunkId] + ".chunk.js";
};